import { useEffect, lazy, useMemo } from "react";
import { HelmetProvider } from "react-helmet-async";
import {
  AuthProvider,
  FilterProvider,
  LayoutProvider,
  LanguageProvider,
  SoundProvider,
} from "@/context";
import { SidebarProvider } from "../context/SidebarContext";
import { useDispatch } from "react-redux";
import { getSetting } from "../redux/settingSlice";
import { toast } from "sonner";
import { useOrderNotification } from "../hooks";
import useSocket from "../hooks/useSocket";
const ShopProvider = lazy(() => import("@/context/useShoppingContext"));


const backendURL =
  import.meta.env.MODE === "development"
    ? import.meta.env.VITE_BACKEND_URL
    : import.meta.env.VITE_BACKEND_URL_PROD;

const AppProvidersWrapper = ({ children }) => {
  const handleChangeTitle = () => {
    if (document.visibilityState == "hidden")
      document.title = "Please come back :-(";
    else document.title = "SU PIZZA DOSTAVA - Delivery Dashboard";
  };

  useEffect(() => {
    import("preline");

    document.addEventListener("visibilitychange", handleChangeTitle);
    return () => {
      document.removeEventListener("visibilitychange", handleChangeTitle);
    };
  }, []);

  const dispatch = useDispatch();

  const fetchSettings = () => {
    dispatch(getSetting())
      .unwrap()
      .then(() => {
        console.log("Settings fetched successfully");
      })
      .catch((err) => {
        toast.error(err.message, {
          position: "top-right",
          autoClose: 2000,
        });
      });
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const showNewOrderNotification = useOrderNotification();
  const handleOrderDetails = (order) => {
    if (order?._id) showNewOrderNotification(order);
  };
  const subscriptionData = useMemo(
    () => ({
      event: "waiting-for-orders",
      data: 1234,
      unsubscribeEvent: "leaving-the-waiting-for-orders",
    }),
    [1234]
  );

  const socket = useSocket(
    backendURL, // Replace with your backend URL
    "new-order-submited",
    handleOrderDetails,
    subscriptionData
  );

  useEffect(() => {
    // Other useEffect for settings fetching
    const handleUserGesture = () => {
      // You can also handle audio playback logic here if needed
    };

    window.addEventListener("click", handleUserGesture);
    window.addEventListener("keydown", handleUserGesture);

    return () => {
      window.removeEventListener("click", handleUserGesture);
      window.removeEventListener("keydown", handleUserGesture);
    };
  }, []);

  return (
    <SidebarProvider>
      <SoundProvider>
        <LanguageProvider>
          <HelmetProvider>
            <LayoutProvider>
              <AuthProvider>
                <ShopProvider>
                  <FilterProvider>{children}</FilterProvider>
                </ShopProvider>
              </AuthProvider>
            </LayoutProvider>
          </HelmetProvider>
        </LanguageProvider>
      </SoundProvider>
    </SidebarProvider>
  );
};
export default AppProvidersWrapper;
